import { object, string } from 'yup';

export const useUnitValidation = (t: any, createPage: any, editPage: any) => {
  const unitInputLabel = t(createPage.form.name.label);
  const unitMinValidationMessage = t(createPage.form.name.minValidation);

  const externalIdRequiredMessage = t(
    editPage.form.externalId.requiredValidation
  );
  const externalIdSourceRequiredMessage = t(
    'web.admin.channel.units.create.form.externalIdSource.validation.required'
  );

  const unitValidator = object().shape(
    {
      name: string()
        .label(unitInputLabel)
        .trim()
        .required()
        .min(1, unitMinValidationMessage),
      externalIdSource: string().when('externalUnitId', {
        is: (externalUnitId: string) => Boolean(externalUnitId),
        then: string().required(externalIdSourceRequiredMessage),
        otherwise: string().notRequired(),
      }),
      externalUnitId: string().when('externalIdSource', {
        is: (externalIdSource: string) => Boolean(externalIdSource),
        then: string().trim().required(externalIdRequiredMessage),
        otherwise: string().notRequired(),
      }),
    },
    [['externalIdSource', 'externalUnitId']]
  );

  return { unitValidator };
};
